<template>
  <v-dialog
    v-model="dialog"
    width="90%"
    height="90%"
    content-class="white overflow-hidden"
    @click:outside="cancel"
  >
    <mcs-card
      v-if="loaded"
      title="Finalize Artwork"
      subtitle="Adjust the position and cropping of your uploaded image to choose what will be printed on your promotional product."
      :outlined="false"
    >
      <div class="d-flex h-full w-full">
        <div
          class="d-flex mx-auto cropper-wrapper"
          :style="`max-width:${windowWidth}px; height: ${windowHeight}px`"
        >
          <div class="buttons">
            <mcs-btn
              color="black"
              class="white rounded-lg mr-2"
              icon
              prepend-icon="mdi-magnify-plus-outline"
              iconSize="36"
              @click="zoom(1.1)"
            ></mcs-btn>
            <mcs-btn
              color="black"
              class="white rounded-lg"
              icon
              @click="zoom(0.9)"
              prepend-icon="mdi-magnify-minus-outline"
              iconSize="36"
            ></mcs-btn>
          </div>
          <Cropper
            :key="id"
            ref="cropper"
            background-class="cropper-background"
            foreground-class="cropper-foreground"
            :src="item.url"
            :stencil-props="{
              aspectRatio: aspectRatio,
              handlers: {},
              movable: false,
              resizable: false
            }"
            :default-position="defaultPosition"
            :default-size="defaultSize"
            :default-transforms="defaultTransforms"
            image-restriction="none"
          />
        </div>
      </div>
      <template #actions>
        <mcs-btn
          :loading="uploading"
          color="black"
          @click="save"
        >
          Save
        </mcs-btn>
      </template>
    </mcs-card>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import { mapGetters } from 'vuex';
export default {
  components: {
    Cropper
  },
  props: {},
  data: () => ({
    dialog: false,
    saving: false,
    valid: false,
    loaded: false,
    uploading: false,
    imgHeight: 0,
    imgWidth: 0,
    item: {}
  }),
  computed: {
    id() {
      return 'cropper';
    },
    windowHeight() {
      return window.innerHeight - 350;
    },
    windowWidth() {
      return window.innerWidth - 200;
    },
    aspectRatio() {
      return (this.item.width || 1) / (this.item.height || 1);
    },
    defaultTransforms() {
      return {
        rotate: 0
      };
    },
    ...mapGetters({})
  },
  methods: {
    cancel() {
      this.loaded = false;
      this.dialog = false;
    },
    show(item) {
      this.uploading = false;
      this.dialog = true;
      this.item = cloneDeep(item);
      this.getImageDimensions(this.item.url).then(() => {
        this.loaded = true;
      });
    },
    defaultPosition({ imageSize }) {
      const height = (imageSize.width * this.item.height) / this.item.width;
      return {
        top: (imageSize.height - height) / 2,
        left: 0
      };
    },
    defaultSize({ imageSize }) {
      const width = imageSize.width;
      const height = (width * this.item.height) / this.item.width;
      return {
        width: width,
        height: height
      };
    },
    getImageDimensions(imageUrl) {
      return new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = () => {
          this.imgHeight = img.naturalHeight;
          this.imgWidth = img.naturalWidth;
          resolve();
        };

        img.onerror = (error) => {
          reject(new Error(`Failed to load image from URL: ${imageUrl}. Error: ${error}`));
        };

        img.src = imageUrl;
      });
    },
    save() {
      const self = this;
      const { canvas } = this.$refs.cropper.getResult();
      canvas.toBlob(function (blob) {
        self.uploading = true;
        self.$store
          .dispatch('printcart/uploadPromoFinal', {
            file: blob,
            publicId: self.item.publicId,
            url: self.item.url
          })
          .then(() => {
            self.cancel();
          })
          .catch((error) => {
            self.logError(error, 'An error occurred while uploading cropped image.');
          })
          .finally(() => {
            self.uploading = false;
          });
      });
    },
    zoom(factor) {
      this.$refs.cropper.zoom(factor);
    }
  }
};
</script>

<style>
.cropper-wrapper {
  overflow: hidden;
  position: relative;
  background: black;
}
.cropper-background {
  background-repeat: repeat;
  background-image: repeating-conic-gradient(lightgray 0% 25%, #fff 25% 50%);
  background-size: 20px 20px;
}
.cropper-foreground {
  opacity: 0.25;
}
.vue-simple-line {
  border-color: #000000 !important;
  border-width: 1.5px !important;
}
.buttons {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 100;
  display: flex;
}
</style>
